import { api, Api } from '@/services/api';
import type {
  LeaderboardEntry,
  LeaderboardParams,
  Season,
  SeasonsParams,
} from '@/types';

const leaderboardEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    seasons: builder.query<{ data: Season[] }, SeasonsParams>({
      query: (params) => ({ url: Api.Seasons, params }),
      providesTags: ['Leaderboard'],
    }),
    leaderboard: builder.query<LeaderboardEntry[], LeaderboardParams>({
      query: (params) => ({ url: Api.Leaderboard, params }),
      providesTags: ['Leaderboard'],
    }),
  }),
});

export const { useSeasonsQuery, useLeaderboardQuery } = leaderboardEndpoints;
